import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getChartDetails } from "../../api/report";
import { transformListing } from "../../utils/listing";
import ReportTheme from "../common/ReportTheme";
import TimeToSellChart from "../common/TimeToSellChart";
import useQueryParams from "../common/useQueryParams";

export default function ReportTimeToSellChart() {
  const { reportId } = useParams();
  const queryParams = useQueryParams();
  const [listings, setListings] = useState([]);
  const [theme, setTheme] = useState(undefined);
  const width = queryParams.get("width")
    ? Number(queryParams.get("width"))
    : undefined;
  const height = queryParams.get("height")
    ? Number(queryParams.get("height"))
    : undefined;

  useEffect(() => {
    getChartDetails(reportId, "time_to_sell").then((details) => {
      setListings(
        details.listings
          .map(transformListing)
          .filter((listing) => !listing.isHidden)
      );
      setTheme(details.theme);
    });
  }, [reportId]);

  return (
    <ReportTheme theme={theme}>
      <TimeToSellChart
        width={width}
        height={height}
        listings={listings}
        hasLabel
        horizontalLegends
      />
    </ReportTheme>
  );
}
